import GiftingLanding from "./GiftingLanding";

export { Page }

function Page() {
  return <GiftingLanding />;
}